<template>
  <div class="contact">
    <h2>预约试用</h2>
    <div class="text">请填写表单信息，我们团队将尽快与您联系！</div>
    <form>
      <div>
        <span>姓名<span>*</span></span>
        <input type="text">
      </div>
      <div>
        <span>邮箱<span>*</span></span>
        <input type="text">
      </div>
      <div>
        <span>手机<span>*</span></span>
        <input type="text">
      </div>
      <div>
        <span>公司名称<span>*</span></span>
        <input type="text">
      </div>
      <div>
        <span>公司规模<span>*</span></span>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div>
        <span>留言</span>
        <input type="text">
      </div>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value:'',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
    }
  },
}
</script>
<style lang="stylus" scoped>
.contact {
  background: url("~@/assets/img/other/BI/BI-banner.png") top left no-repeat;
  background-size: cover;
  padding-top: 178px
  & h2 {
    text-align: center;
    margin-bottom: 20px;
    font-size: 40px;
    line-height: 56px;
    color: rgba(0, 0, 0, 0.85);
  }
  & .text {
    text-align: center;
    font-size: 18px;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.5);
  }
  form {
    width: 590px;
    font-size: 18px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px #EFF1F7;
    opacity: 1;
    border-radius: 10px;
    margin: 60px auto;
    padding: 60px 69px;
    box-sizing: border-box;
  }
}
</style>
